const mods2require = require('mods2require');

module.exports = function requireDirectory(appDir, directoryPath) {
  const mods = mods2require(appDir, directoryPath);
  return mods.map(mod => {
    const module = require(mod.requirePath);
    return {
      moduleName: mod.moduleName,
      module: (module.default) ? module.default : module,
      importPath: mod.importPath,
    };
  });
};

